var documentComponent;
var datalayerService;
function openManuModal(el) {
    var manuEl = el.parentElement;
    datalayerService.setModal(true);
    if (manuEl.id) {
        documentComponent.openManufacturerModal(manuEl.id);
    } else {
        documentComponent.openManufacturerModal(manuEl.getAttribute('data-pid'));
    }

    
}

/*
    Modal functions related to Google Recaptcha V3
*/
function reloadCaptcha() {
    documentService.isLockedByCaptcha = true;
    documentComponent.recaptchaWidgetId = grecaptcha.enterprise.render('recaptcha-container',
        {
            "sitekey": "6LfAWrQtAAAAAJPj_zTOffpA0wIAWKeTiaTFFIPj",
            "action": "verify",
            "theme": "light",
            "callback": "succesfulRecaptchaSubmit"
        });
}

function succesfulRecaptchaSubmit() {
    var captchaTokenData = {
        "event": {
            "token": "TOKEN",
            "expectedAction": "verify",
            "siteKey": "6LfAWrQtAAAAAJPj_zTOffpA0wIAWKeTiaTFFIPj",
        }
    }

    documentService.isLockedByCaptcha = false;
    documentComponent.closeCaptchaModal();
}